import Dialog from './Dialog';
import DialogProviderImport, { useDialog as useDialogImport } from './DialogProvider';
import './dialog.scss';

export default Dialog;
export const DialogProvider = DialogProviderImport;
export const useDialog = useDialogImport;
